import React, { useState, useRef, useEffect } from 'react';
import RolesList from './RolesList';
import ViewRole from './ViewRole';
import { useTranslation } from 'react-i18next';
import ResizablePanels from '../../components/Layout/ResizablePanels';
import './Users.css';

// Roles management with master-detail view
const Roles = () => {
  const { t } = useTranslation('admin');
  const [selectedRoleId, setSelectedRoleId] = useState(null);
  const [viewMode, setViewMode] = useState('list'); // Start with 'list' like Users
  const listRef = useRef();
  const viewRef = useRef();

  useEffect(() => {
    updateToolbar(viewMode);
  }, [viewMode, t]);

  const updateToolbar = (mode) => {
    let toolbar = null;

    if (mode === 'list') {
      // List view
      toolbar = (
        <>
          <button className="toolbar-btn" onClick={handleNew}>
            <span className="icon">➕</span> {t('common:ui.new')}
          </button>
          <button className="toolbar-btn" onClick={handleRefresh}>
            <span className="icon">🔄</span> {t('common:ui.refresh')}
          </button>
        </>
      );
    } else if (mode === 'create') {
      // Create mode
      toolbar = (
        <>
          <button className="toolbar-btn primary" onClick={handleSave}>
            <span className="icon">💾</span> {t('common:ui.save')}
          </button>
          <button className="toolbar-btn" onClick={handleCancel}>
            <span className="icon">✖</span> {t('common:ui.cancel')}
          </button>
        </>
      );
    } else if (mode === 'edit') {
      // Edit mode
      toolbar = (
        <>
          <button className="toolbar-btn primary" onClick={handleSave}>
            <span className="icon">💾</span> {t('common:ui.save')}
          </button>
          <button className="toolbar-btn" onClick={handleCancel}>
            <span className="icon">✖</span> {t('common:ui.cancel')}
          </button>
        </>
      );
    } else {
      // View mode
      toolbar = (
        <>
          <button className="toolbar-btn" onClick={handleEdit}>
            <span className="icon">✏️</span> {t('common:ui.edit')}
          </button>
          <button className="toolbar-btn danger" onClick={handleDelete}>
            <span className="icon">🗑️</span> {t('common:ui.delete')}
          </button>
          <button className="toolbar-btn" onClick={handleBack}>
            <span className="icon">⬅️</span> {t('common:ui.back')}
          </button>
        </>
      );
    }

    if (window.setRolesToolbar) {
      window.setRolesToolbar(toolbar);
    }
  };

  const handleSelectRole = (roleId) => {
    setSelectedRoleId(roleId);
    setViewMode('view');
  };

  const handleBack = () => {
    setSelectedRoleId(null);
    setViewMode('list');
  };

  const handleNew = () => {
    setSelectedRoleId(null);
    setViewMode('create');
  };

  const handleEdit = () => {
    setViewMode('edit');
  };

  const handleCancel = () => {
    if (viewMode === 'create') {
      setViewMode('list');
      setSelectedRoleId(null);
    } else {
      setViewMode('view');
    }
  };

  const handleSave = () => {
    if (viewRef.current) {
      viewRef.current.handleSave();
    }
  };

  const handleDelete = () => {
    if (viewRef.current) {
      viewRef.current.handleDelete();
    }
  };

  const handleRefresh = () => {
    if (listRef.current) {
      listRef.current.fetchRoles();
    }
  };

  const handleRoleCreated = (roleId) => {
    setSelectedRoleId(roleId);
    setViewMode('view');
    if (listRef.current) {
      listRef.current.fetchRoles();
    }
  };

  const handleSaveComplete = () => {
    setViewMode('view');
    if (listRef.current) {
      listRef.current.fetchRoles();
    }
  };

  return (
    <div className="departments-page">
      <ResizablePanels
        leftPanel={
          <RolesList
            ref={listRef}
            onSelectRole={handleSelectRole}
            selectedRoleId={selectedRoleId}
            onNew={handleNew}
          />
        }
        rightPanel={
          viewMode !== 'list' ? (
            <ViewRole
              ref={viewRef}
              roleId={selectedRoleId}
              editMode={viewMode === 'edit'}
              createMode={viewMode === 'create'}
              onBack={handleBack}
              onEdit={handleEdit}
              onSave={handleSaveComplete}
              onCancel={handleCancel}
              onRoleCreated={handleRoleCreated}
            />
          ) : null
        }
        leftCollapsed={viewMode !== 'list'}
        defaultLeftWidth={40}
        minLeftWidth={30}
        maxLeftWidth={70}
      />
    </div>
  );
};

export default Roles;
